/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const BatchAction = zod.enum(['add', 'remove', 'update']);

export type BatchAction = zod.input<typeof BatchAction>;
export type BatchActionOutput = zod.output<typeof BatchAction>;
